/* eslint-disable */
import 'vite/modulepreload-polyfill'
/* eslint-enable */

import 'normalize.css/normalize.css'
import 'scss/signup.scss'

import { configure } from 'shared/config'
import { render } from 'shared/renderReact'
import { initSentry } from 'shared/utils/sentry'

import { App } from './App'

initSentry('signup')
console.info(`[signup] frontend build ${COMMITHASH}`)
configure({
  i18nNamespaces: ['myStores'],
}).then(() => render(App))
